export default __webpack_public_path__ + "static/media/visitor-identification-svgrepo-com.8c220e45.svg";